import { createElement } from 'react';
const TabPane = props => {
    const { title, isCollapsed, onClick } = props;
    const tabPaneClass = isCollapsed ? 'au-tab-pane-title-active' : '';
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };
    return (createElement("li", { className: `au-tab-pane-title ${tabPaneClass}`, onClick: () => handleClick() },
        createElement("span", { className: "au-tab-pane-text" }, title)));
};
export default TabPane;
